import { render, staticRenderFns } from "./SheetFileTab.vue?vue&type=template&id=3f343bbb&scoped=true"
import script from "./SheetFileTab.vue?vue&type=script&lang=js"
export * from "./SheetFileTab.vue?vue&type=script&lang=js"
import style0 from "./SheetFileTab.vue?vue&type=style&index=0&id=3f343bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f343bbb",
  null
  
)

export default component.exports